import React, {PureComponent} from 'react';
import {SwitchButton, SwitchButtonState} from "../SwitchButton/SwitchButton";
import Button from "react-bootstrap/Button";
import {
    DispensingOrdersFuelsStock,
    DispensingOrdersViewState,
    IDispensingOrdersSearchBarProps,
    IDispensingOrdersSearchBarState
} from "./models";

export class DispensingOrdersSearchBar extends PureComponent<IDispensingOrdersSearchBarProps, IDispensingOrdersSearchBarState> {
    constructor(props: any) {
        super(props);
        this.state = {
            viewState: DispensingOrdersViewState.VIEW,
            fuelStock: DispensingOrdersFuelsStock.COMMERCIAL
        };
    }


    onWarehouseChange = (active: SwitchButtonState) => {
        this.setState({
            ...this.state,
            fuelStock: SwitchButtonState.LEFT === active ? DispensingOrdersFuelsStock.COMMERCIAL : DispensingOrdersFuelsStock.EXCISE
        }, () => {
            this.props.onFuelStockChange(this.state.fuelStock);
        });
    };

    onViewChange = (view: DispensingOrdersViewState) => {
        this.props.onViewChange(view);
    };


    render() {

        return (
            <div className="bar-position">
                <h2 className='text-light'>
                    Väljastuskorraldused
                </h2>
                <div className="card mb-5">
                    <div className="card-body">
                        <div className='d-flex flex-wrap flex-md-nowrap flex-column flex-md-row'>

                            {
                                this.props.viewState === DispensingOrdersViewState.VIEW &&
                                <Button variant={"primary"}
                                        className={"h-100 ml-auto"}
                                        type={"button"}
                                        onClick={() => this.onViewChange(DispensingOrdersViewState.NEW)}>
                                    <span className="px-5">
                                        Loo uus
                                    </span>
                                </Button>
                            }
                            {
                                (this.props.viewState === DispensingOrdersViewState.NEW
                                    || this.props.viewState === DispensingOrdersViewState.EDIT
                                ) &&
                                <>
                                    <Button variant={"secondary"}
                                            className={"h-100 "}
                                            onClick={() => this.onViewChange(DispensingOrdersViewState.VIEW)}>
                                    <span className="px-5">
                                        Tagasi
                                    </span>
                                    </Button>
                                    <SwitchButton
                                        size="md"
                                        className="mx-auto mr-md-0 d-flex mt-2 mt-md-0 "
                                        onActiveChange={this.onWarehouseChange}
                                        labelLeft={"Kommertsladu"}
                                        labelRight={"Aktsiisiladu"}/>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
